import script from "./DualSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./DualSlider.vue?vue&type=script&setup=true&lang=js"

import "./DualSlider.vue?vue&type=style&index=0&id=3fd18d4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fd18d4a"]])

export default __exports__